import { Autocomplete, Stack, TextField } from "@mui/material"
import { useState } from "react"
import { searchFeeHeads } from "../../api"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"

const AddFeeCompSingle = ({ add, ...props }) => {
  const [feeHeads, setFeeHeads] = useState([])
  const [inputValue, setInputValue] = useState("")
  const [feeComp, setFeeComp] = useState({
    amount: "0",
    discount: "0",
  })

  const [searching, setSearching] = useState(false)

  const fetchFeeHeads = (value) => {
    searchFeeHeads(value)
      .then((res) =>
        setFeeHeads(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => console.log(err))
      .finally(() => setSearching(false))
  }

  const handleFeeCompChange = (event) => {
    const { name, value } = event.target
    setFeeComp({
      ...feeComp,
      [name]: value,
    })
  }
  return (
    <Modal
      {...props}
      title="Add Fee Component"
      actionText={"Add"}
      action={() => {
        const externals = {}
        if (!feeComp.feeHeadId) externals["feeHead"] = inputValue
        add({ ...feeComp, ...externals })
        setFeeComp({
          amount: "0",
          discount: "0",
        })
        props.close()
      }}
    >
      <FormItem label="Fee Head">
        <Autocomplete
          loading={searching}
          freeSolo
          value={feeComp.feeHeadId}
          onChange={(_, newValue) => {
            setFeeComp({
              ...feeComp,
              feeHeadId: newValue?.id,
              feeHead: newValue?.name,
            })
          }}
          inputValue={inputValue}
          onInputChange={(_, newInputValue) => {
            setInputValue(newInputValue)
            fetchFeeHeads(newInputValue)
          }}
          getOptionLabel={(option) => option.label}
          options={feeHeads}
          renderInput={(params) => <TextField {...params} />}
        />
      </FormItem>
      <Stack direction="row" spacing={2} alignItems="center">
        <FormItem label="Amount">
          <TextField
            type="number"
            name="amount"
            value={feeComp.amount}
            onChange={handleFeeCompChange}
          />
        </FormItem>
        <FormItem label="Discount">
          <TextField
            type="number"
            name="discount"
            value={feeComp.discount}
            onChange={handleFeeCompChange}
          />
        </FormItem>
      </Stack>
    </Modal>
  )
}

export default AddFeeCompSingle
